import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;

  button {
    background: var(--red);

    &:hover:enabled {
      background: var(--red) !important;
      opacity: 0.9;
    }
  }
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
`;

export const ConfirmationInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-weight: normal;
  color: var(--grey-100);

  ul {
    margin-left: 1.6rem;
    display: flex;
    flex-direction: column;
    gap: 0.6rem;

    li {
      &:first-of-type {
        margin-top: 0.4rem;
      }

      font-size: 0.98rem;
      font-family: Inter, sans-serif;
    }
  }

  p {
    &:last-of-type {
      margin-top: 1rem;
    }
  }
`;

export const HelpText = styled.small`
  font-size: 0.98rem;
  color: var(--red);
`;
